import { render, staticRenderFns } from "./IdleVehiclePanel.vue?vue&type=template&id=6960a3e2&scoped=true"
import script from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
export * from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./IdleVehiclePanel.vue?vue&type=style&index=0&id=6960a3e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960a3e2",
  null
  
)

export default component.exports